// src/App.js
import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; // <- make sure this is here
import HomePage from './Views/HomePage';
import ProjectsPage from './Views/Projects';
import Privacy from './Views/Privacy';
import CookieConsent from "./components/CookieConsent";
import Services from './Views/Services';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <CookieConsent />

    </BrowserRouter>
  );
}

export default App;
